
import { SystemConfiguration } from "@nt-portal/server-sdk";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useEffect, useState } from "react";
import { translate } from "../../common";
import { ValidationInput } from '../../components';
import { SettingsEditorItem } from '../../types';
import { ColorPicker, ColorPickerChangeEvent } from "primereact/colorpicker";
import { MultiSelect } from "primereact/multiselect";
import FbxColorPicker from "../color-picker/color-picker";

export interface ExtendedSystemConfiguration extends SystemConfiguration {
    display?: string;
}

export interface SettingEditorProp {
    item?: ExtendedSystemConfiguration;
    onSave: (item?: SettingsEditorItem) => void;
    id?: string;
}

export function SettingsEditor(props: SettingEditorProp) {

    const [_item, setItem] = useState<ExtendedSystemConfiguration | undefined>(props.item);

    useEffect(() => {
        let item = { ...props.item } as ExtendedSystemConfiguration;
        item.busy = false
        setItem(item);
    }, [props.item])


    const handleStringChange = (e: any) => {
        let settingValue = '';
        let value = e.target.value;
        if (Array.isArray(value)) {
            settingValue = value.join(",")
        } else {
            settingValue = value?.toString()
        }
        if (_item) {
            let item = { ..._item };
            item.value = settingValue;
            setItem(item);
        }

    }

    const handleDropdown = (e: any) => {
        if (_item) {
            let item = { ..._item };
            item.value = e.value;
            setItem(item);
        }
    }



    const handleBooleanChange = (e: InputSwitchChangeEvent) => {
        let settingValue = e.value;
        if (_item) {
            let item = { ..._item };
            item.value = settingValue;
            setItem(item);
            if (props.onSave) {
                props.onSave(item);
            }
        }

    }

    const handleColorChange = (target: HTMLDivElement, color: any) => {
        let settingValue = color;
        if (_item) {
            let item = { ..._item };
            item.value = settingValue;
            setItem(item);
            if (props.onSave) {
                props.onSave(item);
            }
        }

    }

    const handleBlur = () => {
        if (props.item?.value !== _item?.value) {
            if (_item) {
                let item = { ..._item };
                item.busy = true;
                setItem(item);
            }
            if (props.onSave) {
                props.onSave(_item);
            }
        }
    }

    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            handleBlur();
        }
    }


    const spinnerStyle = {
        display: _item?.busy ? 'inline-block' : 'none',
        height: '16px',
        width: '16px',
        marginLeft: '5px',
    }

    const renderStringEditor = () => {

        if (_item?.editorType === "dropdown") {
            _item.dropDownOptions?.forEach(i => {
                i.name = translate(i.name)
            })
            return (
                <div className="field" style={{ width: '100%', padding: 5 }} >
                    <label htmlFor="email-host">{_item?.display}</label>
                    <br></br>
                    <ValidationInput className="lim-dropdown" optionLabel="name" optionValue="value" keyName="theme" id={props.id} type="dropdown" required options={_item.dropDownOptions} value={_item?.value} onChange={handleDropdown} onBlur={handleBlur} />
                </div>

            )
        }

        if (_item?.editorType === "multiselect") {
            
            _item.dropDownOptions?.forEach(i => {
                i.name = translate(i.name)
            })
            
            return (

                <div className="field" style={{ width: '100%', padding: 5 }} >
                    <label htmlFor="email-host">{_item?.display}</label>
                    <br></br>
                    <MultiSelect className="lim-dropdown" optionLabel="name" optionValue="value" multiple={true}  id={props.id} type="dropdown" options={_item.dropDownOptions} value={_item?.value} onChange={handleDropdown} onBlur={handleBlur} /> 
                    
                </div>

            )
        }

        return (
            <div className="field" style={{ padding: 5 }}  >
                <label htmlFor="email-host">{_item?.display}</label>
                <br></br>
                <span className="p-input-icon-right" style={{ width: '100%' }}>
                    <i className="pi pi-spin pi-spinner" style={spinnerStyle} />
                    {_item?.editorType === "multiline_text" ?
                        <InputTextarea rows={4} onChange={handleStringChange} onBlur={handleBlur} value={_item?.value} style={{ width: '100%' }}></InputTextarea> :
                        <InputText id={props.id} type={_item?.editorType === "password" ? "password" : "text"} onKeyDown={handleKeyDown} required value={_item?.value} aria-describedby="item-help"
                            onChange={handleStringChange} onBlur={handleBlur} style={{ width: '100%' }} />
                    }

                </span>
            </div>
        )
    }


    const renderNumberEditor = () => {
        return (
            <div className="field" style={{ padding: 5 }}  >
                <label htmlFor="email-host">{_item?.display}</label>
                <span className="p-input-icon-right" style={{ width: '100%' }}>
                    <i className="pi pi-spin pi-spinner" style={spinnerStyle} />
                    <InputText id={props.id} type="number" required value={_item?.value} aria-describedby="item-help"
                        onChange={handleStringChange} onBlur={handleBlur} style={{ width: '100%' }} />
                </span>
            </div>
        )
    }

    const renderBooleanEditor = () => {
        return (
            <div className="field"  >

                <label className="" htmlFor="item-authors">{_item?.display}</label>
                <div className="">

                    <InputSwitch checked={_item?.value} onChange={handleBooleanChange} />
                    <i className="pi pi-spin pi-spinner" style={{...spinnerStyle, fontSize: 25, width: 26, height: 26 }} />
                </div>


            </div>

        )
    }

    const renderColorEditor = () => {
        return (
            <div className="p-fluid field" >

                <label className="p-mb-2" htmlFor="color-picker">{_item?.display}</label>

                <br></br>
                {/* <ColorPicker style={{ width: 200 }} id="color-picker" className="fbx-color-picker" value={_item?.value} onChange={handleColorChange} /> */}

                <FbxColorPicker  style={{ width: 200 }} id="color-picker" className="fbx-color-picker" value={_item?.value} onChange={handleColorChange}/>
                <i className="pi pi-spin pi-spinner" style={spinnerStyle} />
            </div>
        )
    }

    const renderEditor = () => {

        if (_item?.editorType) {
            switch (_item?.editorType) {
                case "boolean": return renderBooleanEditor();
                case "dropdown":
                case "multiline_text":
                case "password": return renderStringEditor();
                case "color": return renderColorEditor();
                default: return renderStringEditor();
            }

        } else {

            if (_item) {
                switch (_item.dataType) {
                    case "string_array":
                    case "string": return renderStringEditor();
                    case "integer":
                    case "float": return renderNumberEditor();
                    case "boolean": return renderBooleanEditor();
                    default: return renderStringEditor();
                }
            }
        }
        return (<div></div>)
    }

    return (
        <div>
            {renderEditor()}

        </div>
    )

}